// extracted by mini-css-extract-plugin
export var colorSquare = "_sx-0";
export var danger = "_sx-5";
export var lightPink = "_sx-8";
export var neutralBlue = "_sx-7";
export var neutralYellow = "_sx-6";
export var normal = "_sx-1";
export var primary = "_sx-2";
export var primaryLight = "_sx-3";
export var solidBlack = "_sx-g";
export var solidGreen = "_sx-b";
export var solidLightBlue = "_sx-d";
export var solidNavy = "_sx-c";
export var solidOrange = "_sx-f";
export var solidPink = "_sx-e";
export var solidRed = "_sx-9";
export var solidYellow = "_sx-a";
export var success = "_sx-4";